// extracted by mini-css-extract-plugin
export var cardContainer = "_n1-0";
export var cardHeader = "_n1-2";
export var collapsedState = "_n1-3";
export var dragHandle = "_n1-5";
export var dragHandleIcon = "_n1-6";
export var dragging = "_n1-1";
export var titleArea = "_n1-4";